const REQUEST_NOTIFICATIONS = 'platfi-ui-app/NOTIFICATIONS/REQUEST_NOTIFICATIONS';
const REQUEST_NOTIFICATIONS_SUCCESS = 'platfi-ui-app/NOTIFICATIONS/REQUEST_NOTIFICATIONS_SUCCESS';
const REQUEST_NOTIFICATIONS_FAILURE = 'platfi-ui-app/NOTIFICATIONS/REQUEST_NOTIFICATIONS_FAILURE';
const START_NOTIFICATION_POLLING = 'platfi-ui-app/NOTIFICATIONS/START_NOTIFICATION_POLLING';
const STARTED_NOTIFICATION_POLLING = 'platfi-ui-app/NOTIFICATIONS/STARTED_NOTIFICATION_POLLING';
const STOP_NOTIFICATION_POLLING = 'platfi-ui-app/NOTIFICATIONS/STOP_NOTIFICATION_POLLING';
const NOTIFICATION_POLLING_SUCCESS = 'platfi-ui-app/NOTIFICATIONS/NOTIFICATION_POLLING_SUCCESS';
const REQUEST_MARK_AS_SEEN = 'platfi-ui-app/NOTIFICATIONS/REQUEST_MARK_AS_SEEN';
const REQUEST_MARK_AS_READ = 'platfi-ui-app/NOTIFICATIONS/REQUEST_MARK_AS_READ';

export {
  REQUEST_NOTIFICATIONS,
  REQUEST_NOTIFICATIONS_SUCCESS,
  REQUEST_NOTIFICATIONS_FAILURE,
  START_NOTIFICATION_POLLING,
  STARTED_NOTIFICATION_POLLING,
  STOP_NOTIFICATION_POLLING,
  NOTIFICATION_POLLING_SUCCESS,
  REQUEST_MARK_AS_SEEN,
  REQUEST_MARK_AS_READ,
};
